import extendNode from '../extendNode.mjs'
import useArCatNode from '../_AR_CAT/useArCatNode.jsx'
import meta from './metaUeRule.mjs'

export default () => {
    const ArCatNode = useArCatNode()

    return extendNode(ArCatNode, {
        ...meta,

        canLinkType(map, node, type) {
            return /^(ISRFREQ)$/.test(type)
        },

        getText(map, node) {
            return `${this.name.slice(0, 4)}\n${this.name.slice(4)}`
        },

        menuItemsInsertProduct(map, node) {
            return [
                {type: 'ISRFREQ'},
            ]
        },
    })
}
